import { Schema } from 'effect';

export const AttributeCode = Schema.String.check(Schema.isPattern(/^[a-z0-9][a-z0-9_-]*$/)).pipe(
  Schema.brand('Listing.AttributeCode')
);

export type AttributeCode = typeof AttributeCode.Type;

export const AttributeValueKey = Schema.String.pipe(Schema.brand('Listing.AttributeValueKey'));

export type AttributeValueKey = typeof AttributeValueKey.Type;

export const StockLocationCode = Schema.String.check(Schema.isPattern(/^[a-z][a-z0-9-]*$/)).pipe(
  Schema.brand('Listing.StockLocationCode')
);

export type StockLocationCode = typeof StockLocationCode.Type;
